import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class TouchedErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return !!(control && control.invalid && control.touched);
    }
}
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ImgsCollection } from 'src/app/interfaces/images/imgs-collection.interface';
import { AlertService } from 'src/app/services/alerts.service';
import { PathsDataService } from 'src/app/services/paths-data.service';
import { RestartpassService } from './restartpass-service/restartpass.service';

@Component({
  selector: 'app-restartpass-page',
  templateUrl: './restartpass-page.component.html',
  styleUrl: './restartpass-page.component.scss'
})
export class RestartpassPageComponent {
  /* =========================== ATRIBUTES =========================== */
  title = 'Login - Ayuda Catastro GA';
  matcher = new TouchedErrorStateMatcher();
  bgRestartPass?: string;
  focusedInput: string = '';
  form: FormGroup;
  isLoading: boolean = false;
  successMessage: boolean = false;
  errorMessage: boolean = false;
  isButtonEnable?: boolean;

  /* ========================== CONSTRUCTOR ========================== */
  constructor(
    private titleService: Title,
    private pathsDataService: PathsDataService,
    private fb: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    private restartpassService: RestartpassService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, this.customEmailValidator, Validators.minLength(6), Validators.maxLength(100)]],
    });
  }


  /* ============================ METHODS ============================ */
  /* --------------------- Meth. Lifecycle Hooks --------------------- */
    ngOnInit(): void {
      this.titleService.setTitle(this.title);
      this.resquestPathImgs();
      this.isButtonEnable = true;
    }

  /* -------------------------- Meth. HTML -------------------------- */
  handleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.form.valid) {
      this.onSubmit(event);
    }
  }

  onFocus(input: string) {
    this.focusedInput = input;
  }

  onBlur() {
      this.focusedInput = '';
  }

  /* ------------------------- Meth. Common ------------------------- */
  customEmailValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value;
  
    if (!value) {
      return null;
    }
  
    // Regex robusto basado en RFC 5322 simplificado
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  
    if (!emailRegex.test(value)) {
      return { invalidEmail: true };
    }
  
    // Carácteres realmente peligrosos (inyección / XSS / no válidos en correos)
    const dangerousCharsRegex = /[()<>\\[\];:"`,]/;
  
    if (dangerousCharsRegex.test(value)) {
      return { invalidChars: true };
    }
  
    // Protección adicional: evita inyecciones SQL por correo
    const sqlInjectionKeywords = /\b(SELECT|INSERT|UPDATE|DELETE|DROP|WHERE|EXEC|UNION|--|;)\b/i;
    if (sqlInjectionKeywords.test(value)) {
      return { sqlInjection: true };
    }
  
    return null;
  }


  onSubmit(event: Event) {
    if (this.form.valid) {
      this.isLoading = true;
      this.successMessage = false;
      this.errorMessage = false;
      this.isButtonEnable = false;

      const email = this.form.value.email;

      this.restartpassService.updateAccessCodeAndSendEmail(email).subscribe({
        next: response => {
          this.isLoading = false;

          if (response.success) {
            this.form.reset();
            this.successMessage = true;
            setTimeout(() => {
              this.successMessage = false;
            }, 2000);
            this.isButtonEnable = true;
            this.alertService.showAlert('Correo electrónico enviado correctamente', 'success');
            setTimeout(() => {
              this.router.navigate(['/iniciar-sesion']);
              this.alertService.showAlert('Ahora la contraseña temporal y tu contraseña registrada funcionan para iniciar sesión', 'info');
            }, 5000);

          } else {
            this.errorMessage = true;
            setTimeout(() => {
              this.errorMessage = false;
            }, 2000);
            this.isButtonEnable = true;
            this.alertService.showAlert('El usuario no existe, por favor verifique el correo electrónico', 'error');
          }
        },
        error: err => {
          this.isLoading = false;
          this.isButtonEnable = true;
          this.errorMessage = true;
          setTimeout(() => {
            this.errorMessage = false;
          }, 2000);
          console.error('Error al enviar el correo:', err);
          this.alertService.showAlert('Hubo un error al enviar el correo electrónico. Por favor, inténtalo de nuevo más tarde.', 'error');
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  /* -------------------- Meth. Modal load file -------------------- */


  /* ------------------------ Meth. Services ------------------------ */
  resquestPathImgs() {
    this.pathsDataService.getPathImgs()
    .subscribe({
        next: (data: ImgsCollection) => {
            this.bgRestartPass = data.login_register.bgRestartPass;
        },
        error: (error) => {
            console.error(error);
        }
    });
  }


  /* ----------------------- Meth. Listening ----------------------- */

}
